<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M-9.5,790.02c0-0.39,0.31-0.69,0.69-0.69c0.39,0,0.69,0.31,0.69,0.69c0,0.17-0.06,0.32-0.15,0.44l0.91,2.5l1.28-0.46
	l0.27,0.75l-0.56,0.21l2.47,6.79l-0.42,2.2l-1.74-1.39l-2.48-6.82l-0.56,0.2l-0.27-0.75l1.28-0.46l-0.93-2.55
	C-9.31,790.59-9.5,790.33-9.5,790.02L-9.5,790.02z M-7.8,793.96l1.92,5.27l0.57,0.46l0.13-0.63l-1.94-5.34L-7.8,793.96L-7.8,793.96z
	 M-6.48,788.38c0-0.39,0.3-0.69,0.69-0.69s0.69,0.3,0.69,0.69c0,0.08-0.01,0.15-0.04,0.22l0.02-0.01l1.57,2.24l1.11-0.78l0.46,0.65
	l-0.49,0.34l4.14,5.92l0.16,2.24l-2.04-0.89l-4.16-5.94l-0.49,0.34l-0.46-0.65l1.11-0.78l-1.55-2.22c-0.01,0-0.03,0-0.04,0
	C-6.18,789.07-6.48,788.77-6.48,788.38L-6.48,788.38z M-3.77,786.14c0-0.39,0.31-0.69,0.69-0.69c0.39,0,0.69,0.31,0.69,0.69
	c0,0.04,0,0.08-0.01,0.12l1.87,1.57l0.87-1.04l0.61,0.51l-0.38,0.46l5.55,4.66l0.71,2.11l-2.22-0.36l-5.53-4.65l-0.39,0.46
	l-0.61-0.51l0.87-1.04l-1.92-1.61c-0.04,0.01-0.08,0.01-0.12,0.01C-3.46,786.83-3.77,786.53-3.77,786.14L-3.77,786.14z
	 M-3.71,791.91l3.19,4.55l0.67,0.3l-0.04-0.65l-3.23-4.61L-3.71,791.91L-3.71,791.91z M-1.9,783.26c0-0.39,0.3-0.69,0.69-0.69
	c0.33,0,0.61,0.23,0.68,0.53l2.19,1.02l0.57-1.23l0.72,0.34l-0.25,0.54l6.57,3.07l1.23,1.85l-2.23,0.23l-6.55-3.06l-0.25,0.54
	l-0.72-0.34l0.57-1.23l-2.15-1c-0.11,0.07-0.24,0.11-0.38,0.11C-1.6,783.95-1.9,783.64-1.9,783.26L-1.9,783.26z M-0.4,788.92
	l4.25,3.57l0.7,0.11l-0.21-0.65l-4.27-3.59L-0.4,788.92L-0.4,788.92z M2.06,785.14l4.99,2.33l0.72-0.07l-0.36-0.56l-5.04-2.35
	L2.06,785.14L2.06,785.14z"/>
</svg>

</template>